var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWHat1NewHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "w-hat1_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#783C55",
    d: "M598.8,180.3c-5.4-1.3-10.7-2.8-15.9-4.5c-40.2-13.8-81.2-31.3-115.6-57.3c-0.7-32-11.9-64.4-39.7-85.4 c-28-19.3-62.2-19.3-93.2-15.1c-5.2,0.9-10.4,2.2-15.5,3.6c-15.3,4.5-29.6,11.2-41.8,19.9c-4.1,3.1-8.1,6.5-11.8,10.1 c-3.7,3.6-7.1,7.5-10.3,11.6c-3.1,4.3-6,8.8-8.4,13.6c-8,16.8-12.2,35.7-10.5,54.6c-30.8,42.2-83.8,63.5-132.4,81.1 c-4.4,1.4-8.7,2.8-13.1,4.1c44,27.4,99,16.4,145.5-0.5c5.1-1.6,10.2-3.2,15.3-4.8c20.4-6.3,41-12.1,61.9-14.8 c6-0.8,12-1.4,18.1-1.7c9.2,0.1,18.5,0.1,27.9,0.1c31.1,1.9,61,9,91,13.7c6,0.9,12,1.8,18.1,2.6c5,0.7,10.2,1.3,15.3,1.7 s10.4,0.7,15.6,0.7c37.5,1.5,77.8-7.6,107.2-31.5C603.9,181.5,601.3,180.9,598.8,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F2335",
    d: "M467.3,118.5c-0.2-9.4-1.3-18.9-3.5-28c-5.5,0.9-11.1,1.7-16.6,2.3c-21.9,1.7-43.7,3.6-65.5,5.4 c-5.5,0.5-10.9,0.9-16.3,1.3c-4.1,0.2-8.2,0.4-12.3,0.6c-22.7,0.7-45.3,2.9-67.9,4.5c0.7-5.9,1.5-11.7,2.6-17.5 c1.1-5.6,2.3-11.1,4-16.4c9-24.4,29.5-46.6,54.8-54.2c-4.1,0.4-8.2,0.8-12.3,1.4c-5.2,0.9-10.4,2.2-15.5,3.6 C303.5,26,289.2,32.7,277,41.4c-4.1,3.1-8.1,6.5-11.8,10.1c-3.7,3.6-7.1,7.5-10.3,11.6c-3.1,4.3-6,8.8-8.4,13.6 c-8,16.8-12.2,35.7-10.5,54.6c-30.8,42.2-83.8,63.5-132.4,81.1c-4.4,1.4-8.7,2.8-13.1,4.1c39.7,24.8,88.6,18.1,131.9,4.1 c2.1-1.1,4.1-2.2,6.1-3.3c8.9-5.2,17-11.5,24.2-18.7c17-15.3,23.8-34.4,27.5-54.8c49.9-0.9,100.7-5.4,150.6-8.6 c11.6-1.3,23-3,34.2-5.7c4.4-1,8.7-2.2,13-3.6C474.4,123.6,470.8,121.1,467.3,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M463.9,90.4c-2.6,0.4-5.3,0.8-8,1.2c-0.3,0-0.6,0.1-0.9,0.1c-2.6,0.4-5.2,0.7-7.8,1 c-21.9,1.7-43.7,3.6-65.5,5.4c-5.5,0.5-10.9,0.9-16.3,1.3c-4.1,0.2-8.2,0.4-12.3,0.6c-2.8,0.1-5.6,0.2-8.5,0.3c-0.1,0-0.2,0-0.3,0 c-2.7,0.1-5.3,0.3-8,0.4c-0.3,0-0.7,0-1,0.1c-2.3,0.1-4.5,0.3-6.8,0.4c-1,0.1-2,0.1-2.9,0.2c-1.4,0.1-2.7,0.2-4.1,0.3 c-28.1,2-56.1,4.8-84.4,4.5c-1.3,7.6-1.7,15.3-1.2,23c39.9,0.7,79-4.9,118.6-6.2c4.1-0.2,8.2-0.4,12.3-0.6 c5.4-0.4,10.9-0.9,16.3-1.3c21.8-1.8,43.6-3.8,65.5-5.4c6.2-0.7,12.3-1.6,18.5-2.6C466.7,105.5,465.6,97.9,463.9,90.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M365.4,99.5c-4.1,0.2-8.2,0.4-12.3,0.6c-2.8,0.1-5.6,0.2-8.5,0.3c-0.1,0-0.2,0-0.3,0 c-2.7,0.1-5.3,0.3-8,0.4c-0.3,0-0.7,0-1,0.1c-2.3,0.1-4.5,0.3-6.8,0.4c-1,0.1-2,0.1-2.9,0.2c-1.4,0.1-2.7,0.2-4.1,0.3 c-12.1,0.9-24.2,1.9-36.4,2.7c-0.9,7.8-1.7,15.6-2.7,23.3c24-1.6,47.9-4,72-4.8c4.1-0.2,8.2-0.4,12.3-0.6 c1.1-0.1,2.2-0.2,3.3-0.3v-23C368.5,99.3,367,99.4,365.4,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M467.1,113.2c-0.4-7.7-1.5-15.3-3.3-22.7c-2.6,0.4-5.3,0.8-8,1.2c-0.3,0-0.6,0.1-0.9,0.1 c-2.6,0.4-5.2,0.7-7.8,1c-14.7,1.1-29.3,2.4-44,3.6v23.2c15.1-1.3,30.2-2.6,45.4-3.7C454.8,115.1,461,114.2,467.1,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,106.3c-1.3,7.6-1.7,15.3-1.2,23c15.6,0.3,31.1-0.4,46.6-1.5c1-7.7,1.7-15.6,2.7-23.3 C269.3,105.7,253.3,106.5,237.2,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E6C45",
    d: "M381.7,98.2c-3.9,0.3-7.8,0.6-11.6,0.9v23.2c4.3-0.3,8.7-0.7,13-1.1c6.7-0.6,13.4-1.1,20.1-1.7V96.3 C396.1,97,388.9,97.6,381.7,98.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWHat1NewHair2);
export default __webpack_public_path__ + "static/media/w-hat1_new-hair2.f76c291616e860e08ea42dc96215e034.svg";
export { ForwardRef as ReactComponent };